namespace SPA{
	export namespace Organization
	{
		export namespace gui
		{
			enum State
			{
				UNKNOWN,
				NEW,
				INBETWEEN,
				COMPLETE
			}

			export class IS24ConfigEntry extends AbstractEntry
			{

				private m_Company: Wollmilch.CompanyObject;
				private m_State: State;

				public constructor( obj: Wollmilch.CompanyObject, orga: OrgaTree )
				{
					super( orga );

					this.m_Company	= obj;
					this.m_State		= State.UNKNOWN;

					this.clearTitle();
					this.addTitle( 'ImmobilienScout24 Einstellungen' );
				}

				public rebuild( root: ui.base.BaseHTMLElement|JQuery): IS24ConfigEntry
				{
					super.rebuild( root );

					this.buildWaitingScreen();

					this.getIS24SessionData();

					return this;
				}

				private buildWaitingScreen(): void
				{
					this.empty();

					new ui.base.BaseHTMLElement( 'p' )
					.css(
						{
							'font-size': '2em'
						}
					)
					.append(
						$( new Icon( 'cog', 'fa' ).getElement() ).addClass( 'fa-spin' )
					)
					.append( new ui.base.BaseHTMLElement( 'span' ).text( ' Bitte warten, die Daten werden abgerufen ...' ) )
					.appendTo( this );
				}

				private buildFailedLoading(): void
				{
					this.empty();

					new ui.base.BaseHTMLElement( 'p' )
					.css(
						{
							'font-size': '2em'
						}
					)
					.append( $( new Icon( 'exclamation', 'fa' ).getElement() ) )
					.append(
						new ui.base.BaseHTMLElement( 'span' ).text(
							' Es ist ein Fehler beim Laden der Daten aufgetreten, bitte erneut versuchen.'
						)
					)
					.appendTo( this );
				}

				private getIS24SessionData(): void
				{
					new Wollmilch.AJAX(
						{
							url: 'authenticate/show/' + this.m_Company.ID,
							method: 'GET',
							on:
							{
								success: ( text: string ) =>
								{
									const result = Wollmilch.jsonize( text );

									if ( !result )
									{
										this.buildFailedLoading();

										new ui.base.Button(
											'Erneut versuchen',
											{
												on:
												{
													click: () => this.getIS24SessionData()
												},
												context: "info"
											}
										).rebuild( this );

										return;
									}

									this.buildLayout( result.data || null );
								}
							}
						},
						Wollmilch.AJAXCallbase_e.IS24_V1
					)
					.send();
				}

				private buildLayout( session: Wollmilch.IS24.SessionObject|null ): void
				{
					this.empty();

					/*
						* Zustand ermitteln
						* NEW: Benutzername + Start
						! INBETWEEN: Code + Finish
						! COMPELTE: Zeige
							# Benutzername
							# Code
							' AccessToken
							? Revoke (Disable) Button
					*/

					if ( session === null )
					{
						this.m_State = State.NEW;
					}
					else if ( session.access_token === null )
					{
						this.m_State = State.INBETWEEN;
					}
					else
					{
						this.m_State = State.COMPLETE;
					}

					switch ( this.m_State )
					{
						case State.NEW:				this.buildNew(); break;
						case State.COMPLETE:	this.buildComplete( session as Wollmilch.IS24.SessionObject ); break;
						default:							this.buildFailedLoading(); break;
					}

					return;
				}

				private buildNew(): void
				{
					app.addNotify(
						{
							title: [ 'Neue Authorisierung erstellen' ],
							body: [
								'Es sind derzeit keine Verbindungsdaten zu ImmobilienScout24 bekannt,',
								'es muss eine neue Authorisierung durchgeführt werden!'
							],
							context: "info",
							timeout: Number(app.getConfigValue("ToastTimeout"))
						}
					);

					const form = new ui.Form.Form(
						{
							action: 'authenticate/oauth_start/' + this.m_Company.ID,
							method: 'POST',
							notSwitchable: true,
							submit: ( _m: Wollmilch.AJAXMethod, _u: string, param: ui.Form.IFormParameter ): void =>
							{
								new Wollmilch.AJAX(
									{
										url: _u,
										method: _m,
										data: param,
										on:
										{
											success: ( text: string ) =>
											{
												const result = Wollmilch.jsonize( text );

												if ( result === null || !result.success )
												{
													app.addNotify(
														{
															title: [ 'Schwerwiegender Fehler' ],
															body: [ 'Es ist ein böser Fehler aufgetreten, bitte erneut versuchen!' ],
															context: "danger",
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													this.buildWaitingScreen();

													return;
												}

												this.buildInbetween( result.data.session, result.data.ApprovalURL );
											}
										}
									},
									Wollmilch.AJAXCallbase_e.IS24_V1
								).send();
							}
						}
					).rebuild( this );

					const l_BtnBar = new ui.base.BaseHTMLElement( 'div' );

					new ui.base.Button(
						'Authorisierung starten ...',
						{
							context: 'success',
							size: "xs",
							attr:
							{
								type: 'submit'
							}
						}
					).rebuild( l_BtnBar );

					this.AddInput(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group' ).appendTo( form.Root() ),
						form,
						[
							{
								size:
								{
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								label: 'Benutzername*',
								input: new ui.Form.TextInput(
									null,
									{
										name: 'username',
										pattern: '[a-zA-Z0-9_\-]*'
									}
								)
							}
						]
					);

					form.append( l_BtnBar );

					form.Initialize();

					return;
				}

				private buildInbetween( session: Wollmilch.IS24.SessionObject, approvalURL: string ): void
				{
					this.empty();

					new ui.base.BaseHTMLElement( 'h3' ).text( 'Authorisierung gestartet...' ).appendTo( this );

					new ui.base.BaseHTMLElement( 'div' ).appendTo( this )
						.append(
							new ui.base.BaseHTMLElement( 'span' ).text( 'Immobilienscout24 hat folgenden ' )
						)
						.append(
							new ui.base.BaseHTMLElement( 'span' ).css(
								{
									'font-style': 'oblique',
									'font-weight': 'bold'
								}
							).text( 'Request-Token' )
						)
						.append(
							new ui.base.BaseHTMLElement( 'span' ).text( ' übermittelt:' )
						)
					.append(
						new ui.base.BaseHTMLElement( 'p' ).text( 'Request-Token: ' + session.request_token )
					)
					.append(
						new ui.base.BaseHTMLElement( 'p' ).text( 'Request-Token-Secret: ' + session.request_token_secret )
					)
					.append(
						new ui.base.BaseHTMLElement( 'p' ).text(
							'Nun müssen Sie sich bei Immobilienscout24 Anmelden und ' +
							'dieser Applikation, mit dem Namen \'07701911\', den Zugriff gewähren/bestätigen.'
						)
						.append( ui.$$.br() )
						.append(
							new ui.base.BaseHTMLElement( 'p' ).text(
								'Wichtig: Nach der Bestätigung müssen Sie sich den von Immobilienscout24 generierten Code kopieren ' +
								'und im Textfeld unten einfügen.'
							)
							.addClass(
								'form-require text-danger small-caps'
							)
						)
						.append( ui.$$.br() )
						.append( ui.$$.br() )
						.append( ui.$$.text( 'Klicken Sie bitte auf nachfolgenden Button um die Bestätigung durchzuführen:' ) )
						.append(
							new ui.base.BaseHTMLElement( 'a' )
								.attr( 'target', 'immoscout_24_request_activate' )
								.attr( 'href', approvalURL )
								.addClass( 'btn btn-xs btn-info' )
								.text( 'Zugriff erlauben' )
								.css( 'align', 'center' )
						)
					);

					const form = new ui.Form.Form(
						{
							action: 'authenticate/oauth_accept/' + this.m_Company.ID,
							method: 'POST',
							submit: ( _m: Wollmilch.AJAXMethod, _u: string, params: ui.Form.IFormParameter ) =>
							{
								new Wollmilch.AJAX(
									{
										url: _u,
										method: _m,
										data: params,
										on:
										{
											success: ( text: string ) =>
											{
												const result = Wollmilch.jsonize( text );

												if ( result === null || !result.success )
												{
													app.addNotify(
														{
															title: [ 'Fehler beim Erhalt der Zugriffsberechtigung' ],
															body: [
																'Die Zugriffsberechtigung konnte nicht erhalten werden, bitte starten Sie den Vorgang' +
																'erneut.'
															],
															context: "danger",
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													// ! Hier ein revoke ausführen

													this.buildLayout( null );

													return;
												}

												app.addNotify(
													{
														title: [ 'Erfolg' ],
														body: [ 'Berechtigung erfolgreich erhalten.' ],
														context: "success",
														timeout: Number(app.getConfigValue("ToastTimeout"))
													}
												);

												this.buildLayout( result.data );
											}
										}
									},
									Wollmilch.AJAXCallbase_e.IS24_V1
								).send();
							}
						}
					).rebuild( this );

					form.Initialize();

					this.AddInput(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group' ).appendTo( form ),
						form,
						[
							{
								label: 'Verifikationscode*',
								size:
								{
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								input: new ui.Form.TextInput(
									null,
									{
										name: 'verification-code',
										on:
										{
											keyup()
											{
												this.value = this.value.trim();
											}
										}
									}
								)
							}
						]
					);

					new ui.base.Button(
						'Verifizieren',
						{
							context: "success",
							attr:
							{
								type: 'submit'
							}
						}
					).appendTo( form );

					return;
				}

				private buildComplete( session: Wollmilch.IS24.SessionObject ): void
				{
					this.empty();

					// ! Hier richtig schön den Scheiß anzeigen und auch ein REVOKE anbieten!!!!

					new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'jumbotron' )
						.text( 'Alles hat geklappt, yay!!!!!' )
						.appendTo( this );

					return;
				}

			}
		}
	}
}
